<script>
import VueQr from 'vue-qr'
export default {
  name: "Qrcode",
  components:{VueQr},
  props:{
    visible:{
      type:Boolean,
      default: false
    }
  },
  data(){
    return {
      show:false,
      data:""
    }
  },
  watch:{
    visible(val){
      console.log("切换显示",val)
      this.show = val
      this.data = this.$cloud.userInfo().qrCodeId
    }
  },
  mounted() {
    this.data = this.$cloud.userInfo().qrCodeId
  },
  methods:{
    handleClose(){
      console.log("关闭")
      this.show = false
      this.$emit('update:visible',false)
    }
  }
}
</script>

<template>
  <el-dialog title="我的二维码" :visible.sync="show" @close="handleClose" width="400px">
    <div class="flex p-8 justify-center">
      <vue-qr
          ref="qrcode"
          :margin="0"
          :size="300"
          :text="data"
          class="qrcode"
      />
    </div>
  </el-dialog>
</template>

<style scoped>

</style>
